export class FilterReceta {
  folio: string;
  startDate: string | null;
  endDate: string | null;
  dateFilter: string | null;
  idSucursal?: string | null;
  idGEMP?: string | null;

  constructor(filter: FilterReceta) {
    this.folio = filter.folio || "";
    this.startDate = filter.startDate || null;
    this.endDate = filter.endDate || null;
    this.dateFilter = filter.dateFilter || null;
    this.idSucursal = filter.idSucursal || null;
    this.idGEMP = filter.idGEMP || null;
  }
}
